/* pdp-title-fit.js — ajuste de font-size para que ciertos textos del PDP no
   excedan un nº máximo de líneas:
     · .pdp__title         → H1, máx 2 líneas (36px desktop / 26px mobile).
     · .pdp__consulta-title → "Precio a consultar", máx 1 línea (en móvil la
       columna es estrecha y el copy hacía overflow a 2 filas).
   Partimos del tamaño que fija el CSS por breakpoint y reducimos px a px hasta
   que quepa (o hasta un mínimo legible). Se re-evalúa en resize, tras cargar
   las webfonts (cambian las métricas) y en shopify:section:load (editor). */
(function () {
  var MIN = 14; // px — suelo de legibilidad

  function fitOne(el, maxLines) {
    el.style.fontSize = ''; // parte del valor del CSS (depende del breakpoint)
    var size = parseFloat(getComputedStyle(el).fontSize);
    if (!size) return;
    var guard = 0;
    while (size > MIN && guard < 60) {
      var lh = parseFloat(getComputedStyle(el).lineHeight) || (size * 1.2);
      if (Math.round(el.scrollHeight / lh) <= maxLines) break;
      size -= 1;
      el.style.fontSize = size + 'px';
      guard++;
    }
  }

  function fitAll() {
    var titles = document.querySelectorAll('.pdp__title');
    for (var i = 0; i < titles.length; i++) fitOne(titles[i], 2);
    var consultas = document.querySelectorAll('.pdp__consulta-title');
    for (var j = 0; j < consultas.length; j++) fitOne(consultas[j], 1);
  }

  function init() {
    fitAll();
    // Las webfonts pueden cambiar el ancho del texto tras el primer paint.
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitAll);

    var raf;
    window.addEventListener('resize', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(fitAll);
    });
    // product-info re-renderiza la sección al cambiar de variante; reajusta.
    document.addEventListener('shopify:section:load', fitAll);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
